export const anchorStyle = {
  cursor: 'pointer',
};

export const menuStyle = {
  width: '190px',
};
